export default __webpack_public_path__ + "static/media/blob4.bc860cc5.svg";